import { render } from "./vhpAdminHeader.vue?vue&type=template&id=5f297a15"
import script from "./vhpAdminHeader.vue?vue&type=script&lang=js"
export * from "./vhpAdminHeader.vue?vue&type=script&lang=js"

import "./vhpAdminHeader.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__